import script from "./UnitsOverviewDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitsOverviewDashboard.vue?vue&type=script&setup=true&lang=js"

import "./UnitsOverviewDashboard.vue?vue&type=style&index=0&id=056193f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056193f2"]])

export default __exports__